import React, { lazy, Suspense, useEffect, useState } from "react"

export const SafeLoadMuiComponent = (
  importFn,
  componentName,
  { fallback = null } = {},
) => {
  /* a light stub so styled‑components can still target attrs */
  const MuiStub = React.forwardRef(function MuiSSRStub(props, ref) {
    const { children, ...other } = props
    return (
      <div {...other} ref={ref} data-mui-stub={componentName}>
        {children}
      </div>
    )
  })

  const isSSR = typeof window === "undefined"
  const LazyMui = lazy(() =>
    importFn().catch(() => ({
      default: MuiStub,
    })),
  )

  /* ---------- SERVER ---------- */
  if (isSSR) {
    return function SSRSafeMui(props) {
      return (
        <div suppressHydrationWarning>
          {React.createElement(MuiStub, props)}
        </div>
      )
    }
  }

  /* ---------- CLIENT ---------- */
  return function SafeMui(props) {
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    if (!mounted) {
      return (
        <div suppressHydrationWarning>
          {React.createElement(MuiStub, props)}
        </div>
      )
    }

    return (
      <Suspense fallback={fallback ?? <div suppressHydrationWarning />}>
        <LazyMui {...props} />
      </Suspense>
    )
  }
}
